import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { GraphService } from 'app/shared/graph.service';

declare interface RouteInfo {
  path?: string;
  title: string;
  icon?: string;
  class: string;
  children?: any[];
  isChildIconOpen?: string;
  isChildIconClose?: string;
  isAdmin?: string;
  isDeveloper?: string;
  isQRMAdmin?: string; 
}

export let ROUTES: RouteInfo[] = [];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  isChildShow: boolean;
  public userName: String;
  public isAdmin: any;
  public isDeveloper: any;
  public isQRMAdmin: any;
  public archiveLink = '/upgrade';


  constructor(private graphService: GraphService) {
    this.isAdmin = false;
    this.isDeveloper = false;
    this.isQRMAdmin = false;
  }

  async ngOnInit() {
    if (!!this.graphService.userPermission && this.graphService.userPermission.hasAccess) {
      const permissions = this.graphService.userPermission;
      this.isAdmin = permissions.isAdmin;
      this.isDeveloper = permissions.isDeveloper;
      this.isQRMAdmin = permissions.isQRMAdmin;
      ROUTES = [];
      this.getRoutes(this.isAdmin, this.isDeveloper,this.isQRMAdmin);
      this.menuItems = ROUTES;
    }

    this.graphService.notifyObservable$.subscribe(async (response: any) => {
      if (response && response.data && response.data.hasAccess) {
        const permissions = response.data;
        this.isAdmin = permissions.isAdmin;
        this.isDeveloper = permissions.isDeveloper;
        this.isQRMAdmin = permissions.isQRMAdmin;
        ROUTES = [];
        this.getRoutes(this.isAdmin, this.isDeveloper, this.isQRMAdmin);
        this.menuItems = ROUTES;
      }
    });

    if (!!this.graphService.currentUser) {
      this.userName = this.graphService.currentUser.givenName;
    } else {
      await this.graphService.getCurrentUser().then((data) => {
        this.userName = data.givenName;
      });
    }
    this.isChildShow = true;
  }

  getRoutes(isAdminValue, isDeveloperValue, isQRMAdminValue) {
    return (ROUTES = [
      { 
        path: '/dashboard', 
        title: 'Home', 
        icon: 'home', 
        class: '' 
      },
      {
        path: '/new-request',
        title: 'New Request',
        icon: 'assignment',
        class: '',
      },
      {
        path: '/search-request',
        title: 'Search Request',
        icon: 'search',
        class: '',
      },
      {
        path: '/report',
        title: 'Report',
        icon: 'bar_chart',
        class: '',
        isAdmin: isAdminValue,
        isDeveloper: isDeveloperValue,
        isQRMAdmin: isQRMAdminValue
      },
      {
        path: '/help',
        title: 'Help',
        icon: 'help',
        class: '',
      },
      {
        title: 'Administration',
        icon: 'lock',
        class: '',
        isAdmin: isAdminValue,
        isDeveloper: isDeveloperValue,
        isQRMAdmin: isQRMAdminValue,
        isChildIconOpen: 'keyboard_arrow_down',
        isChildIconClose: 'keyboard_arrow_right',
        children: [
          {
            path: '/administrator',
            title: 'Admin',
            icon: 'visibility',
          },
          {
            path: '/users',
            title: 'Users',
            icon: 'people',
          }
        ]
      }
    ]);
  }

  clickMainMenu(menuItem) {
    if (menuItem.title === 'Administration') {
      this.isChildShow = !this.isChildShow;
    }
  }

}
